import * as THREE from 'three'
import { convertToSvg } from './convertToSvg'
import makerjs from "makerjs";
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader'
import { fabric } from 'fabric';


export function getPathFromSVG(inSvgString) {
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(inSvgString, 'image/svg+xml');
    const pathElement = svgDoc.querySelector('path');
    return pathElement ? pathElement.getAttribute('d') : null;
}


export async function textTo3D(inText, inFontBuffer, inExtrudeSetting) {
    return new Promise(async (resolve, reject) => {
        try {
            if (!inFontBuffer) {
                console.warn("Please select a font");
                return;
            }
            if (!inText) {
                console.warn("Please enter text");
                return;
            }

            const fontName = `customFont_${Date.now()}`;
            const fontFace = new FontFace(fontName, inFontBuffer);
            await fontFace.load();
            document.fonts.add(fontFace);

            const canvas = new fabric.Canvas(null);
            canvas.setDimensions({
                width: 500,
                height: 500
            });

            const textObject = new fabric.Text(inText, {
                fontFamily: fontName,
                fontSize: 200,
                fill: "black"
            });

            const textWidth = textObject.width || 0;
            const textHeight = textObject.height || 0;
            const padding = 100;

            canvas.setDimensions({
                width: textWidth + (padding * 2),
                height: textHeight + (padding * 2)
            });

            textObject.set({
                left: padding,
                top: padding
            });

            canvas.add(textObject);
            canvas.renderAll();

            const blobUrl = canvas.toDataURL();

            const svg = await convertToSvg(blobUrl);
            const model3D = await svgTo3D(svg, inExtrudeSetting);

            resolve(model3D);
        } catch (err) {
            console.error("Error in textTo3D:", err);
            reject(err);
        }
    });
}

// async function fetchFontFile(fontName) {
//     const response = await fetch(`https://fonts.gstatic.com/s/${fontName}/v1/${fontName}.woff2`);
//     const blob = await response.blob();
//     return blob
// }


export async function svgTo3D(svg, inExtrudeSetting) {
    return new Promise(async (resolve, reject) => {

        let path = getPathFromSVG(svg)

        let makerJsPath = makerjs.importer.fromSVGPathData(path)

        // Convet to svg
        let svgString = makerjs.exporter.toSVG(makerJsPath, {
            useSvgPathOnly: true,
            fillRule: "nonzero",
        })

        // Load svg in three js
        let loader = new SVGLoader()
        let paths = loader.parse(svgString).paths

        let shapes = paths[0].toShapes(true);
        let geometry = new THREE.ExtrudeGeometry(shapes, inExtrudeSetting);

        // TODO: Scaling is not working properly that is why
        // we are using the original svg path
        // and scale geometry in three js
        resolve({
            geometry,
            paths,
            shapes,
            pathSVG : path
        })
    })
}
// function resizeImage(img, newWidth) {
    
//     return new Promise((resolve, reject) => {
//         // Create a Fabric canvas
//         var canvas = new fabric.Canvas('canvas');
//         canvas.setDimensions({
//             width: newWidth,
//             height: newWidth
//         })

//         // Load the image data URL onto the canvas
//         fabric.Image.fromURL(img
//             , function (img) {
//                 // Resize the image
//                 img.scaleToWidth(newWidth);

//                 // Add the image to the canvas
//                 canvas.add(img);

//                 // Render the canvas
//                 canvas.renderAll();
//                 resolve(canvas.toDataURL())
//             });
//         })

// }

// function downloadImage(inDataURL) {
//     let a = document.createElement('a')
//     a.href = inDataURL
//     a.download = 'file.png'
//     a.click()
// }

export function removeObjWithChildren(obj) {
    if (obj.children.length > 0) {
        for (var x = obj.children.length - 1; x >= 0; x--) {
            removeObjWithChildren(obj.children[x])
        }
    }
    if (obj.isMesh) {
        obj.geometry.dispose();
        obj.material.dispose();
    }
    if (obj.parent) {
        obj.parent.remove(obj)
    }

}


